/* Estimate Hub — builder controller (sections/estimate-builder.liquid).
   Quantities per tab live in sessionStorage (bb:est:qty:<tab>); the math is
   the pure computeEstimate() below (spec §5), exported for node tests as
   module.exports and exposed as window.bbEstimateMath. Talks to the shared
   tab controller (assets/estimate-hub.js) through window.bbEstimate and the
   bb:est:ready / bb:est:tab / bb:est:summary document events. No framework. */
(function () {
  'use strict';

  /* ---------------- pure math (safe under node) ---------------- */
  function formatMoney(n) {
    n = Math.round(Number(n) || 0);
    var s = String(Math.abs(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (n < 0 ? '-$' : '$') + s;
  }
  function formatRange(low, high) {
    return low === high ? formatMoney(low) : formatMoney(low) + '–' + formatMoney(high);
  }
  function roundTo(v, r) {
    r = Number(r) || 1;
    return r <= 1 ? Math.round(v) : Math.round(v / r) * r;
  }
  function bounds(item) {
    var min = Math.max(0, Number(item && item.min) || 0);
    var max = Number(item && item.max) > 0 ? Number(item.max) : 60;
    var step = Number(item && item.step) >= 1 ? Math.round(Number(item.step)) : 1;
    var floor = min > 0 ? min : step; /* smallest non-zero quantity */
    var ceil = floor + Math.floor(Math.max(0, max - floor) / step) * step;
    return { floor: floor, ceil: ceil, step: step };
  }
  /* 0 is always allowed (unselected); anything else snaps to floor + n×step ≤ ceil. */
  function sanitizeQty(raw, item) {
    var q = Number(raw), b = bounds(item);
    if (!isFinite(q) || q <= 0) return 0;
    if (q <= b.floor) return b.floor;
    q = b.floor + Math.round((q - b.floor) / b.step) * b.step;
    return q > b.ceil ? b.ceil : q;
  }
  function stepQty(current, dir, item) {
    var b = bounds(item), q = sanitizeQty(current, item);
    if (dir > 0) return q === 0 ? b.floor : Math.min(b.ceil, q + b.step);
    return q - b.step < b.floor ? 0 : q - b.step;
  }
  /* items: [{id,name,price,high,unit,tabs,min,max,step,labor}], qtys: {id: qty},
     cfg: {spread, roundTo, labor:{tab:pct}, minimums:{tab:$}}, tab: key.
     Numeric inputs are clamped ≥ 0 here too — the theme editor's number
     settings have no min, so a stray negative must never produce a negative
     estimate. item.labor === false marks an all-in price (retail bouquet,
     per-guest package, delivery): the tab's labor % is charged only on the
     lines that carry it, so a group's printed "from" price and the range the
     builder returns for that one piece agree. Absent flag = labor applies. */
  function computeEstimate(items, qtys, cfg, tab) {
    cfg = cfg || {}; qtys = qtys || {};
    var spread = Math.max(0, Number(cfg.spread) || 0);
    var laborPct = Math.max(0, cfg.labor && cfg.labor[tab] != null ? Number(cfg.labor[tab]) || 0 : 0);
    var minimum = Math.max(0, cfg.minimums && cfg.minimums[tab] ? Number(cfg.minimums[tab]) || 0 : 0);
    var lines = [], subLow = 0, subHigh = 0, laborBaseLow = 0, laborBaseHigh = 0, laborCount = 0;
    (items || []).forEach(function (item) {
      if (!item || !item.tabs || item.tabs.indexOf(tab) === -1) return;
      var qty = sanitizeQty(qtys[item.id], item);
      if (!qty) return;
      var price = Math.max(0, Number(item.price) || 0);
      /* price × (100 + spread) / 100, not price × 1.15: the latter is 57.4999…
         for $50 in binary floating point and rounded the high end down. */
      var unitHigh = item.high != null && Number(item.high) > 0 ? Number(item.high) : Math.round(price * (100 + spread) / 100);
      if (unitHigh < price) unitHigh = price;
      var line = { id: item.id, name: item.name, unit: item.unit, qty: qty, unitLow: price, unitHigh: unitHigh, low: qty * price, high: qty * unitHigh, labor: item.labor !== false };
      line.text = formatRange(line.low, line.high);
      lines.push(line);
      subLow += line.low; subHigh += line.high;
      if (line.labor) { laborBaseLow += line.low; laborBaseHigh += line.high; laborCount += 1; }
    });
    var laborLow = Math.round(laborBaseLow * laborPct / 100), laborHigh = Math.round(laborBaseHigh * laborPct / 100);
    var low = roundTo(subLow + laborBaseLow * laborPct / 100, cfg.roundTo);
    var high = roundTo(subHigh + laborBaseHigh * laborPct / 100, cfg.roundTo);
    return {
      tab: tab, count: lines.length, lines: lines,
      subtotalLow: subLow, subtotalHigh: subHigh, subtotalText: formatRange(subLow, subHigh),
      laborPct: laborPct, laborCount: laborCount, laborLow: laborLow, laborHigh: laborHigh, laborText: formatRange(laborLow, laborHigh),
      low: low, high: high, rangeText: formatRange(low, high),
      minimum: minimum, belowMinimum: minimum > 0 && lines.length > 0 && low < minimum
    };
  }
  var api = { computeEstimate: computeEstimate, sanitizeQty: sanitizeQty, stepQty: stepQty, formatMoney: formatMoney, formatRange: formatRange, roundTo: roundTo };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.bbEstimateMath = api;
  if (window.__bbEstimateBuilder) return;
  window.__bbEstimateBuilder = true;

  /* ---------------- DOM helpers ---------------- */
  var TABS = ['weddings', 'personal', 'corporate', 'activations'];
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var builders = [];
  function reduced() { return reduceMQ.matches; }
  function load(key) { try { return JSON.parse(window.sessionStorage.getItem(key) || 'null'); } catch (e) { return null; } }
  function save(key, val) { try { if (val == null) window.sessionStorage.removeItem(key); else window.sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }
  function currentTab() { var t = window.bbEstimate && window.bbEstimate.tab; return TABS.indexOf(t) > -1 ? t : 'weddings'; }
  function tabLabel(tab) {
    var l = window.bbEstimate && window.bbEstimate.labels && window.bbEstimate.labels[tab];
    return l || { weddings: 'Weddings', personal: 'Personal events', corporate: 'Corporate events', activations: 'Brand activations' }[tab] || tab;
  }
  /* "Brand activations" → "brand activation", "Parties" → "party" (for "a typical …"). */
  function singular(label) {
    var s = String(label || '').toLowerCase();
    if (/ies$/.test(s)) return s.replace(/ies$/, 'y');
    if (/[^s]s$/.test(s)) return s.slice(0, -1);
    return s;
  }
  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  /* A recurring unit ("per delivery", weekly/monthly) marks a line whose
     subtotal repeats — say so in the ledger ("$185–$213 / delivery") instead of
     letting it read as a one-off event number. One-off units (per hour, per
     guest) stay bare: their qty already multiplied into a true one-off total. */
  function recurringSuffix(unit) {
    var u = String(unit || '').trim();
    return /deliver|week|month/i.test(u) ? ' / ' + u.replace(/^per\s+/i, '') : '';
  }
  function whenCore(cb) {
    if (window.bbEstimate) { cb(); return; }
    var done = false, run = function () { if (!done) { done = true; cb(); } };
    document.addEventListener('bb:est:ready', run, { once: true });
    window.setTimeout(run, 2500); /* failsafe: never leave the builder dead if the controller is missing */
  }

  /* --est-minibar-h: the fixed mini-bar (owned by estimate-hub.js) sits over
     the sticky summary card's top offset. Watch its .is-on class from here so
     the CSS variable exists without touching the shared controller. */
  var minibarEl = null, minibarMO = null;
  function syncMinibarVar() {
    var h = minibarEl ? minibarEl.offsetHeight : 0, on = !!(minibarEl && minibarEl.classList.contains('is-on'));
    document.documentElement.style.setProperty('--est-minibar-h', (on ? h : 0) + 'px');
    /* Card landings reserve the bar even while it is off: on ≤999px the core
       hides the bar while the dock owns the bottom edge, and the bar returns
       the moment the card is in view — the very moment the landing is judged.
       The bar keeps its layout box while hidden (opacity/visibility), so its
       height is measurable either way. */
    document.documentElement.style.setProperty('--est-minibar-reserve', h + 'px');
  }
  function wireMinibarVar() {
    var bar = document.querySelector('[data-est-minibar]');
    if (bar === minibarEl) { syncMinibarVar(); return; }
    if (minibarMO) { minibarMO.disconnect(); minibarMO = null; }
    minibarEl = bar;
    if (bar && 'MutationObserver' in window) {
      minibarMO = new MutationObserver(syncMinibarVar);
      minibarMO.observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
    syncMinibarVar();
  }

  /* ---------------- per-section builder ---------------- */
  function Builder(root) {
    var self = this;
    this.root = root;
    this.section = root.querySelector('[data-est-builder]') || root;
    this.cfg = { spread: 15, roundTo: 10, labor: {}, minimums: {}, urls: {}, page: window.location.pathname, anchor: 'estimate' };
    try { Object.assign(this.cfg, JSON.parse(root.querySelector('[data-est-config]').textContent)); } catch (e) {}
    this.items = []; this.rows = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-est-item]'), function (row) {
      var item; try { item = JSON.parse(row.getAttribute('data-est-item')); } catch (e) { return; }
      /* An item never counts on a tab its group is hidden on. */
      var group = row.closest('[data-est-group][data-est-tabs]');
      if (group) { var gt = (group.getAttribute('data-est-tabs') || '').split(/\s+/); item.tabs = (item.tabs || []).filter(function (t) { return gt.indexOf(t) > -1; }); }
      self.items.push(item);
      self.rows[item.id] = { item: item, row: row, input: row.querySelector('[data-est-input]'), dec: row.querySelector('[data-est-dec]'), inc: row.querySelector('[data-est-inc]'), line: row.querySelector('[data-est-line]') };
    });
    this.card = root.querySelector('[data-est-card]');
    this.form = root.querySelector('form.est-form');
    this.dock = root.querySelector('[data-est-dock]');
    this.jumpRow = root.querySelector('[data-est-jump-row]');
    this.maps = {}; this.lastTab = null; this.proposalMode = false;
    this.sectionVisible = false; this.cardVisible = false;
    this.restoreFromUrl();
    this.bind();
    this.renderSuccess();
    this.recompute();
    this.consumeProposalParam();
  }
  var P = Builder.prototype;

  P.mapFor = function (tab) {
    if (!this.maps[tab]) {
      var stored = load('bb:est:qty:' + tab), seeded = {};
      if (!stored && this.lastTab && this.maps[this.lastTab]) {
        /* First visit to this tab: shared pieces carry their count over (spec §5). */
        var prev = this.maps[this.lastTab];
        this.items.forEach(function (it) { if (it.tabs.indexOf(tab) > -1 && it.tabs.indexOf(this.lastTab) > -1 && prev[it.id]) seeded[it.id] = prev[it.id]; }, this);
      }
      this.maps[tab] = stored || seeded;
      if (!stored && Object.keys(seeded).length) this.persist(tab);
    }
    return this.maps[tab];
  };
  P.persist = function (tab) { save('bb:est:qty:' + tab, this.maps[tab]); };
  /* An ?est= deep link IS the estimate: it replaces any stale session
     quantities for its tab instead of merging into them. */
  P.restoreFromUrl = function () {
    if (window.__bbEstimateUrlRestored) return;
    window.__bbEstimateUrlRestored = true;
    var est = new URLSearchParams(window.location.search).get('est');
    if (!est) return;
    var tab = currentTab(), map = {};
    est.split(',').forEach(function (pair) {
      var bits = pair.split(':'), row = this.rows[(bits[0] || '').trim()];
      if (!row) return;
      var q = sanitizeQty(bits[1], row.item);
      if (q) map[row.item.id] = q;
    }, this);
    this.maps[tab] = map;
    this.persist(tab);
  };
  /* Success-card "Request a proposal" on hub-form tabs links back with
     ?proposal=1 — consume it: open the form in proposal mode, clean the URL. */
  P.consumeProposalParam = function () {
    var p;
    try { p = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (p.get('proposal') !== '1') return;
    if (this.card && this.card.querySelector('[data-est-success]')) return;
    this.setMode(true);
    if (this.last) this.fillFields(this.last);
    this.openForm(true, true);
    p.delete('proposal');
    try { window.history.replaceState(null, '', window.location.pathname + (p.toString() ? '?' + p.toString() : '') + '#' + this.cfg.anchor); } catch (e) {}
  };
  P.setQty = function (id, qty) {
    var tab = currentTab(), map = this.mapFor(tab), row = this.rows[id];
    if (!row) return;
    map[id] = sanitizeQty(qty, row.item);
    if (!map[id]) delete map[id];
    this.persist(tab);
    this.recompute();
  };
  P.applyStarter = function (tab) {
    var map = this.mapFor(tab);
    this.items.forEach(function (it) {
      var n = it.starters && it.starters[tab] ? sanitizeQty(it.starters[tab], it) : 0;
      if (n && it.tabs.indexOf(tab) > -1) map[it.id] = n; else delete map[it.id];
    });
    this.persist(tab);
    this.recompute();
  };
  /* Tier-scoped starter: a [data-est-starter-items="id:qty,…"] payload loads
     exactly those pieces (falls back to the tab starter if nothing matches). */
  P.applyStarterItems = function (tab, payload) {
    var map = {}, self = this;
    String(payload || '').split(',').forEach(function (pair) {
      var bits = pair.split(':'), r = self.rows[(bits[0] || '').trim()];
      if (!r || r.item.tabs.indexOf(tab) === -1) return;
      var q = sanitizeQty(bits[1], r.item);
      if (q) map[r.item.id] = q;
    });
    if (!Object.keys(map).length) { this.applyStarter(tab); return; }
    this.maps[tab] = map;
    this.persist(tab);
    this.recompute();
  };
  P.clear = function () {
    var tab = currentTab();
    this.maps[tab] = {};
    this.persist(tab);
    this.setMode(false);
    this.openForm(false);
    this.recompute();
    /* The empty card hides the Clear link that was just activated, which would
       drop keyboard focus to <body>; hand it to the starter pill (the card's
       one remaining action) so the visitor's place survives (same as showHint). */
    var starter = this.card && this.card.querySelector('[data-est-starter]');
    if (starter) starter.focus({ preventScroll: true });
  };

  /* Estimate ↔ proposal wording on the shared form (the "Request a proposal
     instead" path must not open a form still labelled "Email me this estimate"). */
  P.setMode = function (proposal) {
    this.proposalMode = !!proposal;
    if (!this.card) return;
    var intro = this.card.querySelector('[data-est-form-intro]');
    if (intro) { var i = intro.getAttribute(proposal ? 'data-intro-proposal' : 'data-intro-estimate'); if (i) setText(intro, i); }
    var submit = this.card.querySelector('[data-est-submit]');
    if (submit) { var l = submit.getAttribute(proposal ? 'data-label-proposal' : 'data-label-estimate'); if (l) setText(submit, l); }
  };

  P.recompute = function () {
    var tab = currentTab(), map = this.mapFor(tab), self = this;
    this.lastTab = tab;
    var res = this.last = computeEstimate(this.items, map, this.cfg, tab);
    var label = tabLabel(tab), sing = singular(label);
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-est-singular]'), function (el) { setText(el, sing); });
    /* rows */
    var byId = {}; res.lines.forEach(function (l) { byId[l.id] = l; });
    Object.keys(this.rows).forEach(function (id) {
      var r = self.rows[id], onTab = r.item.tabs.indexOf(tab) > -1;
      var qty = onTab ? sanitizeQty(map[id], r.item) : 0, b = bounds(r.item);
      if (r.input && document.activeElement !== r.input) r.input.value = String(qty);
      r.row.classList.toggle('est-item--on', qty > 0);
      if (r.dec) r.dec.disabled = qty === 0;
      if (r.inc) r.inc.disabled = qty >= b.ceil;
      if (r.line) {
        /* At qty 1 on a ranged item ($150–$290 · each) the "=" subtotal repeats
           the printed unit range verbatim — suppress the echo. Spread-priced
           items ("From $150") keep it: the line is the only place the visitor
           sees the computed high end. */
        var dup = byId[id] && byId[id].qty === 1 && Number(r.item.high) > 0;
        r.line.hidden = !byId[id] || dup;
        if (byId[id] && !dup) setText(r.line, '= ' + byId[id].text);
      }
    });
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-est-group]'), function (g) {
      var any = Array.prototype.some.call(g.querySelectorAll('[data-est-item]'), function (row) { var r = self.rows[row.getAttribute('data-est-id')]; return r && r.item.tabs.indexOf(tab) > -1; });
      g.hidden = !any;
    });
    /* Jump-index chips mirror their group's computed visibility (a group can be
       tab-on yet empty); the summary chip sits outside the row and is never hidden. */
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-est-jump-row] [data-est-jump]'), function (a) {
      var g = document.getElementById((a.getAttribute('href') || '').slice(1)), li = a.closest('li');
      if (li) li.hidden = !g || g.hidden === true;
    });
    this.updateJumpFade();
    /* The mobile starter pill under the sub-heading only earns its place while
       the current tab's estimate is empty. */
    var headStart = this.root.querySelector('[data-est-head-start]');
    if (headStart) headStart.hidden = !!res.count;
    /* card */
    if (this.card && !this.card.querySelector('[data-est-success]')) {
      var q = function (sel) { return self.card.querySelector(sel); };
      var list = q('[data-est-lines]');
      if (list) {
        list.textContent = '';
        res.lines.forEach(function (l) {
          var li = document.createElement('li'), a = document.createElement('span'), b = document.createElement('span'), n = document.createElement('span');
          n.className = 'est-lines-qty'; n.textContent = l.qty + ' × ';
          a.appendChild(n); a.appendChild(document.createTextNode(l.name)); b.textContent = l.text + recurringSuffix(l.unit);
          li.appendChild(a); li.appendChild(b); list.appendChild(li);
        });
      }
      if (res.count) this.card.removeAttribute('data-est-empty'); else this.card.setAttribute('data-est-empty', '');
      setText(q('[data-est-subtotal]'), res.subtotalText);
      /* No labor row when the pct is 0 or every selected line is priced all-in. */
      var laborRow = q('[data-est-labor-row]'); if (laborRow) laborRow.hidden = !res.laborPct || !res.laborCount;
      setText(q('[data-est-labor-pct]'), String(res.laborPct));
      setText(q('[data-est-labor]'), res.laborText);
      var minRow = q('[data-est-min-row]'); if (minRow) minRow.hidden = !res.belowMinimum;
      setText(q('[data-est-min]'), formatMoney(res.minimum));
      setText(q('[data-est-range]'), res.rangeText);
      /* One-line echo above the submit pill: on short viewports the card
         scrolls internally and the Playfair range leaves the screen exactly
         while the visitor types — keep the number they are emailing in view. */
      var echo = q('[data-est-form-echo]');
      if (echo) {
        echo.hidden = !res.count;
        setText(q('[data-est-echo-range]'), res.count ? res.rangeText : '');
        setText(q('[data-est-echo-meta]'), res.count ? ' · ' + res.count + (res.count === 1 ? ' item' : ' items') : '');
      }
      this.announce(res.count ? 'Estimated range ' + res.rangeText : 'Nothing added yet');
      var link = q('[data-est-proposal-link]');
      if (link) { var urls = self.cfg.urls || {}; try { urls = JSON.parse(link.getAttribute('data-est-urls')) || urls; } catch (e) {} link.setAttribute('href', urls[tab] || '#' + self.cfg.anchor); }
      /* "Request a proposal instead" only once there is something to be instead
         of; the empty card reads "Or request a proposal" (both owner-editable). */
      var ptext = q('[data-est-proposal-text]');
      if (ptext) { var pl = ptext.getAttribute(res.count ? 'data-est-label' : 'data-est-label-empty'); if (pl) setText(ptext, pl); }
      if (res.count) { var hint = q('[data-est-hint]'); if (hint) hint.hidden = true; }
      this.fillFields(res);
    }
    this.updateDock();
    /* Empty state = empty range text, so the mini-bar's :empty rules hide the
       "$0" figure instead of presenting it as an estimate. */
    document.dispatchEvent(new CustomEvent('bb:est:summary', { detail: { tab: tab, count: res.count, low: res.low, high: res.high, rangeText: res.count ? res.rangeText : '' } }));
    /* The bar re-renders on that event (empty ↔ range) and can change height. */
    window.requestAnimationFrame(syncMinibarVar);
  };
  P.announce = function (text) {
    var self = this, live = this.card && this.card.querySelector('[data-est-range-live]');
    if (!live) return;
    window.clearTimeout(this.liveTimer);
    this.liveTimer = window.setTimeout(function () { setText(live, text); }, 400);
  };
  P.updateDock = function () {
    /* Third-party floaters (Shopify Inbox) are cleared while the builder band
       is on screen at any width — see html.est-builder-vis in the section CSS. */
    document.documentElement.classList.toggle('est-builder-vis', !!this.sectionVisible);
    /* ≤999px jump row: off while the summary card is in view (see .est-jump--off). */
    var nav = this.root.querySelector('[data-est-jumpnav]');
    if (nav) nav.classList.toggle('est-jump--off', !!(this.cardVisible && window.innerWidth < 1000));
    if (!this.dock) return;
    var on = !!(this.last && this.last.count && this.sectionVisible && !this.cardVisible && window.innerWidth < 1000);
    var rangeText = this.last && this.last.count ? this.last.rangeText : '';
    setText(this.dock.querySelector('[data-est-dock-range]'), rangeText);
    /* Five-digit ranges step down to 19px so the italic never runs under the pill. */
    this.dock.classList.toggle('est-dock--long', rangeText.length > 13);
    if (on) this.dock.setAttribute('data-est-dock-on', ''); else this.dock.removeAttribute('data-est-dock-on');
    document.documentElement.classList.toggle('est-dock-on', on);
    this.dock.setAttribute('aria-hidden', on ? 'false' : 'true');
    var cta = this.dock.querySelector('[data-est-dock-cta]'); if (cta) cta.tabIndex = on ? 0 : -1;
  };

  /* Hidden contact[...] rows — filled on every recompute AND at submit so
     bb-form-meta.js never prunes a populated estimate. */
  P.fillFields = function (res) {
    if (!this.form || !res) return;
    var self = this, tab = res.tab, label = tabLabel(tab);
    var set = function (key, val) { var el = self.form.querySelector('[data-est-field="' + key + '"]'); if (el) el.value = val || ''; };
    set('inquiry', (this.proposalMode ? 'Proposal request — ' : 'Estimate Hub — ') + label);
    set('type', tab);
    if (!res.count) { ['items', 'subtotal', 'labor', 'range', 'json', 'link'].forEach(function (k) { set(k, ''); }); return; }
    set('items', res.lines.map(function (l) {
      return l.qty + ' × ' + l.name + ' @ ' + formatRange(l.unitLow, l.unitHigh) + ' ' + (l.unit || 'each') + ' = ' + l.text;
    }).join('\n'));
    set('subtotal', res.subtotalText);
    set('labor', res.laborPct && res.laborCount
      ? res.laborText + ' (' + res.laborPct + '%' + (res.laborCount < res.count ? ' on ' + res.laborCount + ' of ' + res.count + ' lines' : '') + ')'
      : 'None');
    set('range', res.rangeText + (res.belowMinimum ? ' (below the ' + formatMoney(res.minimum) + ' minimum)' : ''));
    /* The 4,000-char cap must always hold valid JSON: drop item names first,
       then trailing items, flagging truncated:true — never slice the string. */
    /* theme: which theme priced this estimate — dev-theme leads (PLACEHOLDER
       prices under owner review) must stay distinguishable from post-launch
       leads in the info@ inbox. */
    var th = window.Shopify && window.Shopify.theme;
    var payload = { tab: tab, low: res.low, high: res.high, spread: this.cfg.spread, labor_pct: res.laborPct, theme: (th && th.id) || null, items: res.lines.map(function (l) { return { id: l.id, qty: l.qty, name: l.name, low: l.low, high: l.high }; }) };
    var json = JSON.stringify(payload);
    if (json.length > 4000) {
      payload.truncated = true;
      payload.items = res.lines.map(function (l) { return { id: String(l.id).slice(0, 64), qty: l.qty, low: l.low, high: l.high }; });
      json = JSON.stringify(payload);
      while (json.length > 4000 && payload.items.length) { payload.items.pop(); json = JSON.stringify(payload); }
    }
    set('json', json);
    /* On an unpublished theme the link must carry preview_theme_id, or the
       lead's deep link lands on the live theme where the template (and the
       ?est= restore) does not exist yet. Self-heals at launch (role 'main'). */
    var link = window.location.origin + this.cfg.page + '?tab=' + tab + '&est=' + res.lines.map(function (l) { return l.id + ':' + l.qty; }).join(',');
    if (th && th.id && th.role && th.role !== 'main') link += '&preview_theme_id=' + th.id;
    set('link', link + '#' + this.cfg.anchor);
  };

  /* ≥1000px the card is sticky and, when a long build outgrows the viewport,
     scrolls internally. An open form must not: with the fields inside a
     scroller the submit pill sat below a 768px viewport and the eyebrow was
     cropped mid-glyph at the card's top border. So the open form takes the
     card out of the sticky flow (.est-card--form-open) and a margin-top holds
     it at the exact screen position it had while stuck; the card then grows
     in the page and the page scrolls to the fields. Closing restores sticky. */
  P.pinCard = function (open) {
    var card = this.card; if (!card) return;
    if (!open) { card.classList.remove('est-card--form-open'); card.style.marginTop = ''; return; }
    if (card.classList.contains('est-card--form-open')) return;
    var before = card.getBoundingClientRect().top;
    card.classList.add('est-card--form-open'); card.style.marginTop = '';
    if (window.innerWidth < 1000) return; /* not sticky below 1000px: nothing to hold in place */
    var shift = before - card.getBoundingClientRect().top;
    if (shift > 1) card.style.marginTop = Math.round(shift) + 'px';
  };
  /* Window resize across the 1000px sticky boundary: the held margin only
     makes sense while the card is sticky-capable. */
  P.syncPin = function () {
    var card = this.card, wrap = card && card.querySelector('[data-est-formwrap]');
    if (!card || !wrap) return;
    if (wrap.hidden || window.innerWidth < 1000) card.style.marginTop = '';
  };
  P.openForm = function (open, focus) {
    var wrap = this.card && this.card.querySelector('[data-est-formwrap]'), btn = this.card && this.card.querySelector('[data-est-open-form]');
    if (!wrap) return;
    var self = this;
    var settled = open === !wrap.hidden && !this.formAnim; /* already in the requested state */
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) this.pinCard(true);
    if (!settled) {
      if (this.formAnim) { wrap.removeEventListener('transitionend', this.formAnim); this.formAnim = null; }
      var finish = function (e) {
        if (e && (e.target !== wrap || e.propertyName !== 'height')) return; /* ignore bubbling child transitions */
        wrap.style.height = ''; wrap.classList.remove('est-formwrap--anim'); wrap.removeEventListener('transitionend', finish); self.formAnim = null;
        if (!open) { wrap.hidden = true; self.pinCard(false); }
      };
      if (reduced()) { wrap.hidden = !open; wrap.style.height = ''; wrap.classList.remove('est-formwrap--anim'); if (!open) this.pinCard(false); }
      else if (open) {
        /* .est-formwrap--anim clips only while the height tweens; at rest the
           wrap must not clip the submit pill's or Close link's focus ring. */
        wrap.hidden = false; wrap.classList.add('est-formwrap--anim'); wrap.style.height = '0px'; void wrap.offsetHeight;
        this.formAnim = finish; wrap.addEventListener('transitionend', finish); wrap.style.height = wrap.scrollHeight + 'px';
      } else {
        wrap.classList.add('est-formwrap--anim'); wrap.style.height = wrap.scrollHeight + 'px'; void wrap.offsetHeight;
        this.formAnim = finish; wrap.addEventListener('transitionend', finish); wrap.style.height = '0px';
      }
    } else if (!open) this.pinCard(false);
    if (open && focus) {
      /* Focus without scrolling, then bring the field into view once the height
         animation settles — focus({preventScroll:false}) used to yank the page
         past the card whenever it was taller than the viewport. */
      var first = wrap.querySelector('[data-est-first-field]');
      if (first) {
        var instant = reduced() || settled;
        window.clearTimeout(this.focusTimer);
        this.focusTimer = window.setTimeout(function () { first.focus({ preventScroll: true }); }, instant ? 0 : 120);
        window.clearTimeout(this.revealTimer);
        this.revealTimer = window.setTimeout(function () {
          first.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
        }, instant ? 0 : 480);
      }
    }
  };
  P.showHint = function () {
    var hint = this.card && this.card.querySelector('[data-est-hint]'), starter = this.card && this.card.querySelector('[data-est-starter]');
    if (hint) hint.hidden = false;
    if (starter) starter.focus();
  };
  P.scrollTo = function (el) { if (el) el.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }); };
  /* ≤999px jump-chip row: same edge fades as the shared tab rows (the core's
     updateFade only watches [data-est-tabgroup]); none when every chip fits. */
  P.updateJumpFade = function () {
    var row = this.jumpRow; if (!row) return;
    if (row.scrollWidth <= row.clientWidth + 1) { row.removeAttribute('data-est-fade'); return; }
    var atStart = row.scrollLeft <= 2, atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
    row.setAttribute('data-est-fade', atStart ? 'right' : (atEnd ? 'left' : 'both'));
  };

  /* Client-side required checks (the form carries novalidate so the browser's
     stock bubble never appears): inline 11px messages + aria-invalid underline. */
  P.checkField = function (input) {
    var v = String(input.value || '').trim(), ok = v.length > 0;
    if (ok && input.type === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    var field = input.closest('.est-field'), err = field && field.querySelector('[data-est-err]');
    if (ok) { input.removeAttribute('aria-invalid'); if (err) err.hidden = true; }
    else { input.setAttribute('aria-invalid', 'true'); if (err) err.hidden = false; }
    return ok;
  };
  P.validate = function () {
    if (!this.form) return null;
    var first = null, self = this;
    Array.prototype.forEach.call(this.form.querySelectorAll('.est-field input[required]'), function (input) {
      if (!self.checkField(input) && !first) first = input;
    });
    return first;
  };

  P.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null; if (!t) return;
      var dec = t.closest('[data-est-dec]'), inc = t.closest('[data-est-inc]');
      if (dec || inc) {
        var row = (dec || inc).closest('[data-est-item]'), r = row && self.rows[row.getAttribute('data-est-id')];
        if (r) self.setQty(r.item.id, stepQty(self.mapFor(currentTab())[r.item.id], inc ? 1 : -1, r.item));
        return;
      }
      var jump = t.closest('[data-est-jump]');
      if (jump) {
        /* Sticky index chips (≤999px): smooth-scroll to the group (its
           scroll-margin-top clears the sticky chrome) and move focus so the
           tab order continues from the landing point. */
        var target = document.getElementById((jump.getAttribute('href') || '').slice(1));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
        return;
      }
      if (t.closest('[data-est-clear]')) { self.clear(); return; }
      if (t.closest('[data-est-close-form]')) {
        /* Retreat to the summary without wiping the build; hand focus back to
           the reappearing trigger so it is not lost inside the hidden form. */
        self.openForm(false);
        var trigger = self.card && self.card.querySelector('[data-est-open-form]');
        if (trigger) trigger.focus({ preventScroll: true });
        return;
      }
      if (t.closest('[data-est-open-form]')) {
        self.setMode(false);
        if (!self.last || !self.last.count) { self.showHint(); return; }
        var btn = t.closest('[data-est-open-form]'), open = btn.getAttribute('aria-expanded') !== 'true';
        self.fillFields(self.last); self.openForm(open, open); return;
      }
      var plink = t.closest('[data-est-proposal-link]');
      if (plink && (plink.getAttribute('href') || '').charAt(0) === '#') {
        /* This tab's proposal destination is the hub form itself — open it as a proposal request. */
        e.preventDefault(); self.setMode(true); if (self.last) self.fillFields(self.last); self.openForm(true, true); return;
      }
      if (t.closest('[data-est-dock-cta]')) {
        e.preventDefault();
        self.scrollTo(self.card);
        /* The dock pill says "Email my estimate" — open the form in the same
           tap instead of landing the visitor on a second identical button. */
        if (self.last && self.last.count) { self.setMode(false); self.fillFields(self.last); self.openForm(true, true); }
        else self.showHint(); /* empty card hides the email pill; point at the starter */
        return;
      }
      if (t.closest('[data-est-build-another]')) {
        var last = load('bb:est:last'); if (last && last.tab) save('bb:est:qty:' + last.tab, null);
        try { window.history.replaceState(null, '', self.cfg.page + '#' + self.cfg.anchor); } catch (err) {}
        window.location.reload();
      }
    });
    root.addEventListener('change', function (e) { self.onInput(e.target); });
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('.est-field input[aria-invalid="true"]')) self.checkField(t);
    });
    root.addEventListener('focusout', function (e) { if (e.target.matches && e.target.matches('[data-est-input]')) self.onInput(e.target); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-est-input]')) { e.preventDefault(); self.onInput(e.target); e.target.blur(); }
    });
    root.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('[data-est-input]') && e.target.select) e.target.select(); });
    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        var res = self.last;
        if (!self.proposalMode && (!res || !res.count)) { e.preventDefault(); e.stopImmediatePropagation(); self.showHint(); return; }
        var bad = self.validate();
        if (bad) {
          e.preventDefault(); e.stopImmediatePropagation();
          bad.focus({ preventScroll: true });
          bad.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        self.fillFields(res);
        var val = function (sel) { var el = self.form.querySelector(sel); return el ? el.value : ''; };
        save('bb:est:last', {
          tab: res.tab, count: res.count, low: res.low, high: res.high, rangeText: res.rangeText,
          lines: res.lines.map(function (l) { return { qty: l.qty, name: l.name, text: l.text }; }),
          items: res.lines.map(function (l) { return l.qty + ' × ' + l.name; }),
          lead_id: val('input[name="contact[Lead ID]"]'), email: val('input[name="contact[email]"]'), name: val('input[name="contact[name]"]'),
          draft: { date: val('[data-est-draft="date"]'), venue: val('[data-est-draft="venue"]') }, at: Date.now()
        });
      }, true);
      /* Re-render after a validation error: Shopify keeps name/email/body only. */
      var wrap = this.form.querySelector('[data-est-formwrap]');
      if (wrap && wrap.hasAttribute('data-est-errors')) {
        var last = load('bb:est:last') || {}, d = last.draft || {};
        Array.prototype.forEach.call(this.form.querySelectorAll('[data-est-draft]'), function (el) { if (!el.value && d[el.getAttribute('data-est-draft')]) el.value = d[el.getAttribute('data-est-draft')]; });
        var btn = this.card.querySelector('[data-est-open-form]'); if (btn) btn.setAttribute('aria-expanded', 'true');
        this.pinCard(true); /* fresh load: the card is at its natural position, no margin needed */
        var err = this.form.querySelector('[data-est-error]'); if (err) { err.scrollIntoView({ block: 'center' }); err.focus({ preventScroll: true }); }
      }
    }
    if (this.jumpRow) this.jumpRow.addEventListener('scroll', function () { self.updateJumpFade(); }, { passive: true });
    if ('IntersectionObserver' in window) {
      this.sectionIO = new IntersectionObserver(function (entries) { self.sectionVisible = entries[entries.length - 1].isIntersecting; self.updateDock(); }, { threshold: 0 });
      this.sectionIO.observe(this.section);
      /* The card counts as "in view" once it is a quarter of the way up the screen, so a sliver peeking in does not hide the dock. */
      if (this.card) {
        this.cardIO = new IntersectionObserver(function (entries) { self.cardVisible = entries[entries.length - 1].isIntersecting; self.updateDock(); }, { threshold: 0, rootMargin: '0px 0px -25% 0px' });
        this.cardIO.observe(this.card);
      }
      this.onResize = function () { self.updateDock(); self.syncPin(); self.updateJumpFade(); };
      window.addEventListener('resize', this.onResize);
    } else { this.sectionVisible = true; }
  };
  /* Editor reloads replace the section DOM — release everything that points at it. */
  P.destroy = function () {
    if (this.sectionIO) { this.sectionIO.disconnect(); this.sectionIO = null; }
    if (this.cardIO) { this.cardIO.disconnect(); this.cardIO = null; }
    if (this.onResize) { window.removeEventListener('resize', this.onResize); this.onResize = null; }
    window.clearTimeout(this.liveTimer);
    window.clearTimeout(this.focusTimer);
    window.clearTimeout(this.revealTimer);
    document.documentElement.classList.remove('est-dock-on');
    document.documentElement.classList.remove('est-builder-vis');
  };
  P.onInput = function (input) {
    if (!input || !input.matches || !input.matches('[data-est-input]')) return;
    var row = input.closest('[data-est-item]'), r = row && this.rows[row.getAttribute('data-est-id')];
    if (!r) return;
    var q = sanitizeQty(input.value, r.item);
    input.value = String(q);
    this.setQty(r.item.id, q);
  };

  /* Success page (?contact_posted=true): line items come back from sessionStorage. */
  P.renderSuccess = function () {
    var box = this.card && this.card.querySelector('[data-est-success]');
    if (!box) return;
    this.card.removeAttribute('data-est-empty'); /* server default; meaningless on the success card */
    var last = load('bb:est:last'), list = box.querySelector('[data-est-success-lines]'), range = box.querySelector('[data-est-success-range]'), pill = box.querySelector('[data-est-success-proposal]');
    if (last && last.lines && last.lines.length && list) {
      last.lines.forEach(function (l) {
        var li = document.createElement('li'), a = document.createElement('span'), b = document.createElement('span');
        a.textContent = l.qty + ' × ' + l.name; b.textContent = l.text; li.appendChild(a); li.appendChild(b); list.appendChild(li);
      });
      list.hidden = false;
      if (range) { range.textContent = last.rangeText; range.hidden = false; }
    }
    if (last && last.tab) { this.maps[last.tab] = {}; save('bb:est:qty:' + last.tab, null); }
    /* The mint surface always carries its ink pill: external proposal URLs go
       straight there; hub-form tabs loop back into proposal mode (?proposal=1). */
    var url = last && this.cfg.urls ? this.cfg.urls[last.tab] : '';
    if (pill) {
      if (url && url.charAt(0) !== '#') pill.setAttribute('href', url);
      else pill.setAttribute('href', this.cfg.page + '?proposal=1#' + this.cfg.anchor);
      pill.hidden = false;
    }
    window.setTimeout(function () { box.focus({ preventScroll: true }); }, 50);
  };

  /* ---------------- wiring ---------------- */
  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.shopify-section'), function (sec) {
      if (!sec.querySelector('[data-est-builder]') || sec.dataset.estBuilderInit) return;
      sec.dataset.estBuilderInit = '1';
      builders.push(new Builder(sec));
    });
    if (scope && scope.matches && scope.matches('.shopify-section') && scope.querySelector('[data-est-builder]') && !scope.dataset.estBuilderInit) {
      scope.dataset.estBuilderInit = '1'; builders.push(new Builder(scope));
    }
  }
  /* The fixed mini-bar's "Email my estimate" pill (owned by the hero section)
     and the closing mint band's "Email my estimate" pills (estimate-cta's
     .est-band-actions) are bare #estimate anchors — route them through the
     dock behavior instead of dropping the visitor at the top of the band with
     the form closed and, on a phone, the card 3,000px further down: scroll to
     the card and open the form in the same tap. The anchors stay for no-JS.
     The shared controller only toggles the mini-bar pill's hidden attribute,
     so claiming the click here conflicts with nothing. */
  function isEstimateAnchor(el) {
    var href = el.getAttribute('href') || '', hash = href.indexOf('#') > -1 ? href.slice(href.indexOf('#') + 1) : '';
    return !!hash && builders.some(function (b) { return b.cfg.anchor === hash; });
  }
  function onSummaryCta(e) {
    var el = e.target.closest && e.target.closest('[data-est-summary-cta], .est-band-actions a[href*="#"]');
    if (!el || !builders.length) return;
    if (!el.hasAttribute('data-est-summary-cta') && !isEstimateAnchor(el)) return;
    e.preventDefault();
    builders.forEach(function (b) {
      b.scrollTo(b.card || b.section);
      if (b.last && b.last.count) { b.setMode(false); b.fillFields(b.last); b.openForm(true, true); }
      else b.showHint();
    });
  }
  function onStarter(e) {
    var el = e.target.closest && e.target.closest('[data-est-starter]');
    if (!el || !builders.length) return;
    e.preventDefault();
    var want = el.getAttribute('data-est-starter') || currentTab();
    if (TABS.indexOf(want) === -1) want = currentTab();
    if (want !== currentTab() && window.bbEstimate && window.bbEstimate.setTab) window.bbEstimate.setTab(want, { source: 'starter', scroll: false });
    var payload = el.getAttribute('data-est-starter-items');
    builders.forEach(function (b) {
      if (payload) b.applyStarterItems(want, payload); else b.applyStarter(want);
      b.scrollTo(window.innerWidth < 1000 && b.card ? b.card : b.section);
    });
  }
  whenCore(function () {
    init(document);
    wireMinibarVar();
    window.addEventListener('resize', syncMinibarVar);
    document.addEventListener('click', onStarter);
    document.addEventListener('click', onSummaryCta);
    document.addEventListener('bb:est:tab', function () { builders.forEach(function (b) { b.setMode(false); b.recompute(); }); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); wireMinibarVar(); });
    document.addEventListener('shopify:section:unload', function (e) {
      builders = builders.filter(function (b) { if (b.root === e.target) { b.destroy(); return false; } return true; });
    });
  });
})();
